export const roadB2C = [

    {
        id: 1,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",
        title: "B2 Cambridge Information",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "Cracking the Cambridge B2: Your Secret Guide", descripcion: "Powerful tips, hidden strategies, and exam hacks that most candidates never learn ", url: "https://drive.google.com/file/d/1cq9H1EAZRlgKWGaIny70AL5s2pkR09ar/view?usp=sharing", url4: "https://youtu.be/5B0AbDJ_1VU?si=CtHAfrrenQB_atMO", url3: "https://youtu.be/rRKs2d7Kl9s" },
            { titulo: "Cambridge B2 First: Unlocking Exam Secrets ", descripcion: "This guide reveals insider tips, secret hacks, and hidden techniques to help you maximise your performance in every section. ", url: "https://drive.google.com/file/d/1vxvFCXalbtMf0ENxDZ3XcM1MZTp_exvG/view?usp=sharing", url3: "https://youtu.be/tBleLH944b4?si=1FuJs-35bCDNyu_Q" },
            { titulo: "How to Calculate Your Exam Score & Pass", descripcion: "This guide explains the step-by-step process so you can check your results", url3: "https://youtu.be/dY198SBKg_U" },

        ],
    },
    {
        id: 2,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple ",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [

            { titulo: "Present Simple Grammar Guide ", descripcion: "This comprehensive guide will teach you all the uses, rules, and structures", url3: "https://youtu.be/u7pyidVI8Rw" },
            { titulo: "Present Simple ", descripcion: "Aprende a usar el present simple en diferentes contextos ", url: "https://drive.google.com/file/d/1rwleyKN1vwRdZLJuHZXbIB3t88hevTl3/view?usp=sharing", url3: "https://youtu.be/hY2sLzte-HQ?si=hKDYW1znThnc-JbX" }



        ],
    },
    {
        id: 3,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Progressive ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [

            { titulo: "Present Progressive", descripcion: "Aprende a usar el present progressive en diferentes contextos ", url: "https://drive.google.com/file/d/1Rqx1bzuRRJbjHZnH_iutOhx7oIzQoeut/view?usp=sharing", url3: "https://youtu.be/movGMBm7zbk" },

        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple vs Present Progressive ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
            { titulo: "Stative & Dynamic Verbs", descripcion: "Completa los niveles para dominar estos tiempos ", url: "https://drive.google.com/file/d/1FG5tjBDMaCCaFOBDxZ039CgdcFevvJcc/view?usp=sharing", url3: "https://youtu.be/R07Mg2YreIg" },

            { titulo: "Present Simple vs Present Progressive ", descripcion: "Completa los niveles para dominar estos tiempos ", url5: "https://learnibox.vercel.app/presentsimpleprogressive" },

        ],
    },
    {
        id: 5,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Past Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
            { titulo: "English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing", url3: "https://youtu.be/-Wp-i77JHM8" },

            { titulo: "Past Simple", url: "https://drive.google.com/file/d/1aAwupScFNRFoNArgtm5f_3k5a0Eyfztt/view?usp=sharing", url3: "https://youtu.be/cZrMl1bTons?si=QOI7p1xaVQV3Bp_B" },
            { titulo: "Past Progressive ", url: "https://drive.google.com/file/d/18QxoihCFpTI0wyWQgr50OZtCdWWNVwqw/view?usp=sharing", },
            { titulo: "Past Simple vs Past Progressive ", descripcion: "Completa los niveles para dominar estos tiempos ", url5: "https://learnibox.vercel.app/pastsimpleprogressive" },

        ],
    },
    {
        id: 6,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Perfect Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
            { titulo: "English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing", url3: "https://youtu.be/-Wp-i77JHM8" },

            { titulo: "Present Perfect", url: "https://drive.google.com/file/d/1Vgvz7c7QrW_FMs5AN70TscKd_z6nh0Pv/view?usp=sharing", url3: "https://youtu.be/FQGoT7jGekQ?si=hvw06VmTNgbysrIT" },
            { titulo: "Past Simple vs Present Perfect", descripcion: "Completa los niveles para dominar estos tiempos ", url5: "https://learnibox.vercel.app/pastsimpleperfect" },

            { titulo: " Present Perfect Progressive", url: "https://drive.google.com/file/d/1XKmee6Sthrl756nWgoifeDb0D6jrob1e/view?usp=sharing" },
            { titulo: " Perfect Simple vs  Perfect Progressive", url: "https://drive.google.com/file/d/1IGrGmE7B44z6YCVSVVSFjWS10CV_mjdC/view?usp=sharing" },

            { titulo: "✍ Past Simple and Present Perfect (Simple and Progressive) ", url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1D0VK7vPjtlAMOc8WqxQUQn62_F3-uJsa/view?usp=sharing", }, { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1jgcxBuSKBZ6LdIQbWXL3_4lJDv4D8QVa/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1jvFbc4GPFUHXIgx0gmbgslQQz7KmIMG0/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1iCSWPTOFu1vGbkEaW6xSPh-Z_-koKr3V/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1uik-f0MFXujPMnbgmOiCIegxSmWAI5qI/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1CyruZuJFKhWpzmNmFQ9H9oigRjqgY0ui/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/1i-A68Tl92LNR87MyIWPPTEceTrIlU_hw/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ", url: "https://drive.google.com/file/d/11Jj4BydUErvqumFiFy5goX5pGQkZq9HY/view?usp=sharing", },
            { titulo: "Future Simple ", url: "https://drive.google.com/file/d/1qv1NHearXkAYne1cH9N0MBc4ikdNtAV-/view?usp=sharing", url2: "https://youtu.be/uaeFf4lMksI?si=uu8wSw6G_svG3v8T" },

            { titulo: "✍ Ways of Expressing Future Tense ", url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
            { titulo: "✍  Future Tenses ", url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
        ],
    },
    {
        id: 7,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Future",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
            { titulo: "English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing", url3: "https://youtu.be/-Wp-i77JHM8" },


            { titulo: "Future Simple ", url: "https://drive.google.com/file/d/1qv1NHearXkAYne1cH9N0MBc4ikdNtAV-/view?usp=sharing", url2: "https://youtu.be/uaeFf4lMksI?si=uu8wSw6G_svG3v8T" },

            { titulo: "✍ Ways of Expressing Future Tense ", url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
            { titulo: "✍  Future Tenses ", url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
        ],
    },

    {
        id: 8,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Essential Grammar ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
            { titulo: "As far as, Until, Up to ", descripcion: "diferencias ", url: "https://drive.google.com/file/d/16CJjTB0ZPDvQuzpOLMR22R0jK7QCe-c3/view?usp=sharing", url3: "https://youtu.be/pa2m8Ja3qBo?si=WicK2xiUfjNCrGZm" },
            { titulo: "Doubt that vs Doubt if", descripcion: "diferencias ", url: "https://drive.google.com/file/d/1qEgnOfM7BoFG1lmMu_xWgNbRlwBTt9X2/view?usp=sharing", url3: "https://youtu.be/7zype2HxL44?si=GBH3KrxdfzI5bCdY" },
            { titulo: "Enough and Too ", url: "https://drive.google.com/file/d/1Tcadp5eOdfsHOlCwJWs0iNuphHQO4gYA/view?usp=sharing", url3: "https://youtu.be/Gie_3C6BIeo" },
            { titulo: "The fact that  ", url: "https://drive.google.com/file/d/1FSd3Vt3C71C0kujDoy4egxFDy8_ZugZv/view?usp=sharing", url3: "https://youtu.be/fXiGq7IuBec" },
            { titulo: "Raise vs Rise..", url: "https://drive.google.com/file/d/1K57hHa19p8k36dka59AM7pyFERFxnap2/view?usp=sharing", url3: "https://youtu.be/iCq1HNpx5aA" },
            { titulo: "in the suburbs vs on the outskirts", url: "https://drive.google.com/file/d/1JMop9SCD1WVrMeQiXTFRD0IcsBqD-vjn/view?usp=sharing", url3: "https://youtu.be/4r4Fa9Zt1FI" },
            { titulo: "Time vs Moment", url: "https://drive.google.com/file/d/1DLFl-bn78Abyr-UQYLh9LN2J45t9UO8Q/view?usp=sharing", url3: "https://youtu.be/IHYu3WXR7yg" },

            { titulo: "Make the most/ the best, Get the better ", url: "https://drive.google.com/file/d/1pQvtcWZpqNw-8sWDfAST6b0DfqpubGz1/view?usp=sharing", url3: "https://youtu.be/GgCg9ZdY1TY" },
            { titulo: "Cleft Sentences", url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing", url3: "https://youtu.be/PKr7p6KBvp4" },





            { titulo: "El Subjuntivo Presente en Inglés", url: "https://drive.google.com/file/d/1mOgCdm3FRZPrVcXErch-VVbfPLkjAyyh/view?usp=sharing", url4: "https://youtu.be/NnAJ2YzwBb0" },

            { titulo: "La Estructura “Need + Verb-ing", url: "https://drive.google.com/file/d/1nYiG9kFlC6eKq3bdZeP7NXblSXxrAc0-/view?usp=sharing", url4: "https://youtu.be/1mvTxoT3F4E" },


            { titulo: "El Presente Continuo para Hablar del Futuro en Inglés", url: "https://drive.google.com/file/d/1ikDyGzOeLljhVhpp_QzaO1B7IswUG0FD/view?usp=sharing", url4: "https://youtu.be/UnLCzBWOVv8" },

            { titulo: "Mastering “Would” vs “Used To” en Inglés: Diferencias", url: "https://drive.google.com/file/d/1V037fa6ebo2IYSnfigdESc3ba44I0aiF/view?usp=sharing", url4: "https://youtu.be/7ueRrDyJ7To" },
            { titulo: "La Construcción It is nice of you ", url: "https://drive.google.com/file/d/13cUcLcuL3RUeuLo_Z2AFhJRoLsXp5shM/view?usp=sharing", url4: "https://youtu.be/2pRAIpj3pLo" },

            { titulo: "If I Had My Way” en Inglés” ", url: "https://drive.google.com/file/d/1dYAFj4142yAIad_hJsswoEJ6ahvWXF4H/view?usp=sharing", url4: "https://youtu.be/ANqiXYG1baM" },
            { titulo: "La Estructura The + Adjective en Inglés ", url: "https://drive.google.com/file/d/1i5J--IifJlphyKHkhcbbcgl9WmQvCuuK/view?usp=sharing", url4: "https://youtu.be/jInF0rW2gIw" },

            { titulo: "Better Yet y Worse Yet/Still en Inglés ", url: "https://drive.google.com/file/d/1Alu1hNgWzPj0S9fzz-L7sTcX8yU_Cojh/view?usp=sharing", url4: "https://youtu.be/kajRjh9Slvg" },


            { titulo: "Domina “Have/Be Yet To” en Inglés Forma", url: "https://drive.google.com/file/d/183t2PttV6cF2jFuqGcodJO1jwQ393noM/view?usp=sharing", url4: "https://youtu.be/WnObWryxyyY" },


            { titulo: "Mastering Passive Reporting Structures en Inglés", url: "https://drive.google.com/file/d/1NiMXPFhxTyeF7aoXabdYJbqFblrqyskV/view?usp=sharing", url4: "https://youtu.be/cAz5VLx1BLE" },

            { titulo: "Inversion with HAD: La Guía Definitiva del 3rd Conditional ", url: "https://drive.google.com/file/d/1i_zI_uOdWTPnuDKzoDpYMwiCk3hKRsix/view?usp=sharing", url4: "https://youtu.be/_yAlO9IK1sM" },
            { titulo: "Inversion with WERE: La Guía Avanzada del Second Conditional", url: "https://drive.google.com/file/d/1cqkgJLR3Bni4pRVLiB3LaRtns37Da1BQ/view?usp=sharing", url4: "https://youtu.be/8_bxl9ihAm4" },

            { titulo: "Should Inversion in the First Conditional", url: "https://drive.google.com/file/d/1ZuB5KhOsQh2jFGFVDnYFAgHBsLKY4PV5/view?usp=sharing", url4: "https://youtu.be/tIEq8ShFlzk" },

            { titulo: "Advanced Grammar: Be Due / Be Sure / Be Bound / Be Set To — Alternativas Formales a “Going To", url: "https://drive.google.com/file/d/1Dyk3p1T0ZKRsI52T4tqInqJs627E-ikn/view?usp=sharing", url4: "https://youtu.be/mZ1vl4mzo9Y" },

            { titulo: "Very as an Adjective", url: "https://drive.google.com/file/d/1FU7MqlXEY4lbZW5k8iufMWU5X6Ypxcdq/view?usp=sharing", url4: "https://youtu.be/V7e_4fEg4D0" },

            { titulo: "Mastering “But For” in English Conditionals", url: "https://drive.google.com/file/d/1nUeXnweowSPom-LsWVErL6BDNKsrhlgv/view?usp=sharing", url4: "https://youtu.be/gqyupeKg04s" },

            { titulo: "Mastering “Be To” in If-Clauses", url: "https://drive.google.com/file/d/1DNHTxpMkIskorC7NoyYI8PqDbw2P3wx7/view?usp=sharing", url4: "https://youtu.be/6VQ3iCbs778" },

            { titulo: "Mastering Inversion with “So”", url: "https://drive.google.com/file/d/1PqObqHkpQUXhRfGyBuFEZ8NZuNLRHap4/view?usp=sharing", url4: "https://youtu.be/bUilFTUV-Aw" },

            { titulo: "It’s High Time”: La Guía Definitiva", url: "https://drive.google.com/file/d/1XLAoY5-uKkx8HPQ4KvgApRIMHLyo4Ufi/view?usp=sharing", url4: "https://youtu.be/MfLnFi4L_W8" },

            { titulo: "La Estructura “The More, The More” en Inglés", url: "https://drive.google.com/file/d/1JGIun4VCWyHvcoAqbCaR6LqYpaAdQNOJ/view?usp=sharing", url4: "https://youtu.be/efMg1CIXh64" },

            { titulo: "Usar “May” para Expresar Deseos en Inglés", url: "https://drive.google.com/file/d/1dk3Z8b6Ppz0TWb1vG4tNLNIrIpxNSPqs/view?usp=sharing", url4: "https://youtu.be/9z9waww_c08" },



            { titulo: "Especially vs. Specially: La Guía Definitiva ", url: "https://drive.google.com/file/d/1Nlfd7f8tLd1HJYzKOFAZ1KPhych-xhEn/view?usp=sharing", url4: "https://youtu.be/o6KlDImyCRI" },
            { titulo: " If vs. Whether: La Guía Definitiva ", url: "https://drive.google.com/file/d/1iU1BzIraEk6xzj99bOxVoEdOyn05YNev/view?usp=sharing", url4: "https://youtu.be/COsaD9QaqlE" },




            { titulo: "Challenges", descripcion: "Completa todos  los niveles", url5: "https://learnibox.vercel.app/essentialgrammar" },
        ],
    },

    {
        id: 9,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Speaking Cambridge",
        subtitle: "B2/C1",
        color: "#8F2BBC",


        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [
            {
                titulo: "B2 Speaking Exam | Structure, Tips & How You’re Assessed",
                url: "https://drive.google.com/file/d/1lQkT1_qz3fPUBqcysqdvxvi6bNtOmXab/view?usp=sharing",
                url2: "https://youtu.be/HcXrztQ7_IE"
            },
            {
                titulo: "Speak About Yourself Naturally (B2–C2 Level)",
                descripcion: "This guide gives you natural vocabulary, idiomatic expressions, and topic-based phrases so you can speak fluently and confidently about your life and experiences.",
                url2: "https://youtu.be/q8I46ZI4pis"
            },
            { titulo: "Mastering Have No Expressions in English", description: "In this guide, you’ll learn the most common “have no” expressions, their meanings and how to use them naturally in both formal and informal contexts.", url2: "https://youtu.be/gT-SWXFclhE" },

            { titulo: "Mastering There Is No & It Is No Expressions", url: "https://drive.google.com/file/d/1jyUmrJVnuw7QOxq7Pvbl9CQRJXdwFkL1/view?usp=sharing", url2: "https://youtu.be/HlWlmC6_-TA" },
            {
                titulo: "🖥️[Video] Episodem  Website",
                url: "https://www.youtube.com/watch?v=9dt6WOuoXos",
            },
            { titulo: "📚[pdf] B2 First Speaking Overview  ", url: "https://drive.google.com/file/d/1QJ_hjTeJIBEb01q5q7L-UeVwwK2sW0Wg/view?usp=sharing" },

            {
                titulo: "🖥️[Video] B2 Speaking Simulation 01",
                url: "https://drive.google.com/file/d/1QhvhLsCjF6V1BaYqpSd3cV9lgNuOCw_h/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 02",
                url: "https://drive.google.com/file/d/1h-s_T2_bFtZngCACYPMKw4U1V4mB6Ove/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 03",
                url: "https://drive.google.com/file/d/1vm6K2C5j061v2IneytvApO-r9tCdd3KS/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 04",
                url: "https://drive.google.com/file/d/1dGhBsbgRejXuovsdRie-bae23WpeY4V6/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 05",
                url: "https://drive.google.com/file/d/1ItqYXZB6Dc19PdmaB67E-9EZyAyfrl9y/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 01",
                url: "https://drive.google.com/file/d/1n-sf1L6DJZKdj0GSGV2zlPlaYI4WhJQ9/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 02",
                url: "https://drive.google.com/file/d/1Jiwqspyx05GE1Br1tTir8j-xWm1_-VbG/view?usp=sharing",
            },

            { titulo: " Bloque 01 ", url: "https://drive.google.com/file/d/1S8x1T_F486L1hYbyPdTeL4rvx-uQXGEt/view?usp=sharing  " },

            { titulo: " Bloque 02 ", url: " https://drive.google.com/file/d/1CA7Ub9WI-QKTBXhZI2S6yBrQV5gez1Jy/view?usp=sharing " },
            { titulo: " Bloque 03 ", url: " https://drive.google.com/file/d/1ETAjorHO8WFszYjEi6b_G6e8FM4i6y6N/view?usp=sharing " },
            { titulo: " Bloque 04 ", url: " https://drive.google.com/file/d/1uvJn25j4BA2gtkdvJZ5qvdY9GZs9Th0_/view?usp=sharing " },
            {
                titulo: "🎯[Activity] speaking Part 1",
                url: "https://wordwall.net/play/519/287/727",
            },
            {
                titulo: "📒[pdf] Linking Words | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1l7NLEB9G7uwaXkRONIKNJE7BjucKC_pC/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] 10 Preguntas de examen – Speaking Parte 1 (Entrevista) | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1Oe2kqUUQnetTzjYCcia8mx2IrPEurE92/view?usp=sharing",
            },

            {
                titulo: "📒[pdf] Speaking Part 1 - Useful Phrases",
                url: "https://drive.google.com/file/d/1Fty0C6H85HUHEJBG0KzAAOGK5a6FVMgz/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 2 - Useful Phrases",
                url: "https://drive.google.com/file/d/1vHp3IrV3Wiz1a2m8_GdbdIl3ITc4sf2e/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 3 - Useful Phrases",
                url: "https://drive.google.com/file/d/19HB0czJM2-XZZBuKr3FXHNAn8jP941DF/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 4 - Useful Phrases",
                url: "https://drive.google.com/file/d/1ZmLmEIS1vnRPbZD9D20vFkEJPpoE9jbm/view?usp=sharing",
            },
            {
                titulo: "📒Mistakes at First ",
                url: "https://drive.google.com/file/d/1GqRFqwYpNz2b52QJIJ9-RIGKOxkEV5HS/view?usp=sharing",
            }


        ],
    },
    {
        id: 10,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Vocabulary Booster ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: " ",
        enlaces: [
            { titulo: "Must-Known Words", descripcion: "Learn the most important words before your exam", url4: "http://learnibox.vercel.app/vocab" },



        ],
    },
    {
        id: 11,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Phrasal Verbs ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: " ",
        enlaces: [
            { titulo: "Advanced Phrasal Prepositional Verbs", descripcion: "108 Phrasal Verbs with 3 words", url2: "https://youtu.be/go0hC3VD9ks", url4: "http://learnibox.vercel.app/108pv" },
            { titulo: "Welcome", descripcion: "Las diferencias en Inglés ", url: "https://drive.google.com/file/d/1VTKLgs-w-Bc-_TPtmNScaaQf0ATs8oCl/view?usp=sharing" },
            { titulo: " Be on about ", descripcion: "Todos los usos y diferencias", url: "https://drive.google.com/file/d/1i5m5Xo0rahB9re9xsLNJdclpA8FA03jy/view?usp=sharing", url3: "https://drive.google.com/file/d/1JDpCXxAU9ozjBMEA2ouhBQGAJgpliOOc/view?usp=sharing" },
            { titulo: "📚Watch out for - Look out for.pdf", url: "https://drive.google.com/file/d/1-E-NvIWN5EmPErBDwZSZmoAQZdgC4g4O/view?usp=sharing" },
            { titulo: "📚ASK FOR - ASK AFTER - ASK ABOUT", url: "https://drive.google.com/file/d/1gkbuIZJ6sRy1jro8NPpOZLKO4p7naizC/view?usp=sharing" },
            { titulo: "Work Out ", url: "https://drive.google.com/file/d/1h4pzMnsgFmBcpRj1QbPbBDjkJ0J9UYfE/view?usp=sharing", url3: "https://drive.google.com/file/d/14ovf4SmbRkZSWQVh-6Q9cOCousRjCrvZ/view?usp=sharing" },
            { titulo: "zero in on  ", descripcion: "Todos los usos y diferencias", url: "https://drive.google.com/file/d/18JztqKh0PP18_LPzUKZDJYnRQqip7x3a/view?usp=sharing", url3: "https://drive.google.com/file/d/19y7aXWFScceuArjQNuN7FjpaLPfALo3w/view?usp=sharing" },
            { titulo: "Shy Away From sth   ", descripcion: "Todos los usos y diferencias", url: "https://drive.google.com/file/d/1LKd3X2Qr8MJ-52QtwBi9f6NR-AWD9anl/view?usp=sharing", url3: "https://drive.google.com/file/d/188wbcEig0wGPF2gscPLlQhF_xayYwKHF/view?usp=sharing" },
            { titulo: "📒Phrasal verb with Get", url: "https://drive.google.com/file/d/1txaA2U2EMDVKnJ--_UM8YhzDZBaHasDP/view?usp=sharing", },
            { titulo: "📒Phrasal verb with Take", url: "https://drive.google.com/file/d/1ZkjaNFOku-6MgJSzH_QRRXHoYGm02uLQ/view?usp=sharing", },
            { titulo: "📒Phrasal verb Get vs Take", url: "https://drive.google.com/file/d/1XyP5ABzwxOESdOwnOucJ_2-3beKDqxwv/view?usp=sharing", },
            { titulo: "📒Phrasal verb with Up", url: "https://drive.google.com/file/d/1B7kiX_3JXK8jiRYNFkR4IxPqoHCz0J7K/view?usp=sharing", },
            { titulo: "📒Phrasal verb Dictation", url: "https://drive.google.com/file/d/1Q78yaqJPpqUThoLZ4y5tqPFp-x6eCV8F/view?usp=sharing", },


        ],
    },

    {
        id: 12,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Cambridge Simulator ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: " ",
        enlaces: [
            { titulo: "Multiple Choice Cloze Simulation I ", descripcion: "The first part of the Use of English paper in the B2 First Examination is multiple choice cloze where students have to choose the correct word from four similar given words.", url4: "https://learnibox.vercel.app/uoepart1" },

            { titulo: "Multiple Choice Cloze Simulation II ", descripcion: "The first part of the Use of English paper in the B2 First Examination is multiple choice cloze where students have to choose the correct word from four similar given words.", url4: "https://learnibox.vercel.app/multiplechoice" },
            { titulo: "Open Cloze", descripcion: "The second part of the Use of English paper in the B2 First Examination is open cloze, in which students use one word to fill each space in a short text. The required words are usually grammatical, such as pronouns, articles, prepositions, auxiliary verbs and so on.", url4: "https://learnibox.vercel.app/uoepart2" },





            { titulo: "Real exam Simulation 01 ", url3: "https://learnibox.vercel.app/simulator" },



            { titulo: "Word Formation", descripcion: "The third part of the Use of English paper in the B2 First Examination is word formation where students use a root such as 'able' and create an appropriate word (disable, unable, ability) to fill the gap in a text.", url: "https://drive.google.com/file/d/1FoMiuTrYJHxJYyBsbBrqvs10Kb8cYf2T/view?usp=sharing", url7: "https://drive.google.com/file/d/1cy_Ap7DUYRZWyCVjPoAYy3njDBlrmXm_/view?usp=sharing", url8: "http://learnibox.vercel.app/tc" },
            { titulo: "✍ WF002 - Prefixes and Negative Meanings ", url: "https://drive.google.com/file/d/1NI-L5UBxQ5gFeRac6oVhMXD_T-5YCjiv/view?usp=sharing", url3: "https://drive.google.com/drive/folders/1T8c6lyVyjh6a2e2MM4M5jeDN8PRcARnR?usp=sharing" },
            { titulo: "✍ WF003 - Crossword - Word Formation ", url: "https://drive.google.com/file/d/194QnF1Gc-wIRpiWAOtqWy-D8B78coaSL/view?usp=sharing", },
            { titulo: "✍ WF019 - Word Formation - Nouns, Verbs, Adjectives ", url: "https://drive.google.com/file/d/18krxCjRSmgc3wfWPtGK2qggwq0lUlfnW/view?usp=sharing", },
            { titulo: "✍ WF020 - Word Formation - Nouns, Verbs, Adjectives ", url: "https://drive.google.com/file/d/18J49WKoMt8jXjiKAcxrFnaqTykF-0QHw/view?usp=sharing", },
            { titulo: "✍ WF021 - Word Formation - Nouns, Verbs, Adjectives ", url: "https://drive.google.com/file/d/17L45VWvsHTY1ToaELcaEXaIpT8bgSKRB/view?usp=sharing", },


            { titulo: "📝 Examen 01  ", url: "https://drive.google.com/file/d/1Sk4W7Ax3Ao9ZqGR4sVY4IFik3Jq6BQ_N/view?usp=sharing" },
            { titulo: "📝 Examen 01 Solucionario ", url: "https://drive.google.com/file/d/13NnSnUDD8m95_AryEwZ5hMnfdxKYrQKV/view?usp=sharing" },

            { titulo: "📝[Test 01 ] FCE + SOLUCIONARIO ", url: "https://drive.google.com/file/d/1sz-WQ4yS7S4GMUgZHXz6uqTD0oA5pJ5M/view?usp=sharing" },
            { titulo: "📝[Test 02 ] FCE + SOLUCIONARIO ", url: "https://drive.google.com/file/d/192v80IEi93ZaiRY1-NkY5h-qk2XyA6O_/view?usp=sharing" },

            { titulo: "📝[Test] Key Word Transformation 01 ", url: "https://drive.google.com/file/d/1Ng-AL8s5uNqA4AeVSa9x-4ySFH_dqsKU/view?usp=sharing" },
            { titulo: "📝🔑[Test Answer Key] Key Word Transformation 01 ", url: "https://docs.google.com/presentation/d/1_lR0KYShBJeyFw-ZOuMIEwwLyIdLb2s591vIc4pAIsU/edit?usp=sharing" },

            { titulo: "📝[Test] Multiple Choice Cloze 01 ", url: "https://drive.google.com/file/d/1Y-2SMBjU5xafwMwdH2VB8NJMWwKQMB5-/view?usp=sharing" },
            { titulo: "📝🔑[Test Answer Key] Multiple Choice Cloze 01", url: "https://docs.google.com/presentation/d/1koBZiWPQtnw6GgFEfWpNORHWd0TvwYYnRbr661Ahh94/edit?usp=sharing" },

            { titulo: "📝[Test] Open Cloze 01 ", url: "https://drive.google.com/file/d/1yRCvF2OW3VJfHSqREMmUb4RzAXK6Hfg1/view?usp=sharing" },
            { titulo: "📝[Test] Word Formation 01 ", url: "https://drive.google.com/file/d/1SOnsELpD7Y4laW2l--YpXeKcut6QM8ZA/view?usp=sharing" },
            { titulo: "🗣[Test] Speaking Section 01 ", url: "https://drive.google.com/file/d/1tG0g65N35lS8hp1r4LRPDSkynxug5C51/view?usp=sharing" },

        ],
    },
    {
        id: 13,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Reading Cambridge ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: " ",
        enlaces: [

            { titulo: "Cambridge B2 Reading", descripcion: "This guide breaks down the structure of the Reading component", url2: "https://youtu.be/E3LtI1q6DSw" },
            { titulo: "Gapped Text Simulations", descripcion: "A single page of text with some numbered gaps which represent missing sentences. After the text there are some sentences which are not in the right order. Students have to read the text and the sentences and decide which sentence best fits each gap.", url3: "https://drive.google.com/file/d/1W-uiH_VebMKmHmdY2JPzsODDyhJa_ayi/view?usp=sharing", url7: "https://drive.google.com/file/d/1W-uiH_VebMKmHmdY2JPzsODDyhJa_ayi/view?usp=sharing", url8: "http://learnibox.vercel.app/gt" },
            { titulo: "Reading Gap Secrets", url: "https://drive.google.com/file/d/1lNpyrE26v78RUX6T9VNWB3yvBuefKYoz/view?usp=sharing", url2: "https://youtu.be/k7N9CSMcA4w?si=5GRKAG9Refk-Pm5i" },
        ],
    },
    {
        id: 30,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Listening Center",
        subtitle: "B2/C1",

        dateAdded: "B2/C1",
        channel: "sdasd",
        description: "Mejora tus habilidades de comprensión auditiva con este curso que te ayudará a entender a hablantes nativos en diferentes situaciones y acentos, fortaleciendo tu confianza al escuchar y comprender el idioma.",
        enlaces: [
            { titulo: "Cambridge B2 Listening", descripcion: "This Advanced Strategic Guide will teach you how to approach each task like a listening detective", url2: "https://youtu.be/w6bEgODSNVc" },

            { titulo: "Listening Test 01", url: "https://drive.google.com/file/d/1D5AdAH1i9YgRKAPjt1hTCTFbZNSzb7mZ/view?usp=sharing" },
            { titulo: "Listening Test 02", url: "https://drive.google.com/file/d/15L0kGEMCnG64fOmwEyHI26fvKXDsRxjj/view?usp=sharing" },
            { titulo: "Listening Test 03", url: "https://drive.google.com/file/d/1MDFFBQWUYZIfHR1Sq8uh7NwUFeEbLabk/view?usp=sharing" },
            { titulo: "Listening Test 04", url: "https://drive.google.com/file/d/1XtMuAyPYc_eOO1ZM5xuPnKZlw8fci5MF/view?usp=sharing" },
            { titulo: "Listening Test 05", url: "https://drive.google.com/file/d/1gbY6fJBvFXn-L3qs_wgK_hvYCIhbfcWJ/view?usp=sharing" },
            { titulo: "Listening Test 06", url: "https://drive.google.com/file/d/1nmFFhMgNcZSmkpYe1PqHQ2lMeIdgghEQ/view?usp=sharing" },
            { titulo: "Listening Test 07", url: "https://drive.google.com/file/d/1C7B6D6Z_e-k9ugmEojOGuVtvmSHe2ojS/view?usp=sharing" },

            { titulo: "🦻Listening Trainer 01", url: "https://drive.google.com/file/d/1MKkEnM6ABu8UmYtqmWdG6wEFbPnNHwIq/view?usp=sharing" },
            { titulo: "🦻Listening B2 TEST 01", url: "https://drive.google.com/file/d/1zLZ9sYxQ9BLNEtLF391_VhItr8mrmCBX/view?usp=sharing" },

            {
                titulo: "🖥️[Video] Listening  Trainer 01",
                url: "https://drive.google.com/file/d/16rLz8vX-25nVKvO2y7_HIJ2j2Ay_-XL_/view?usp=sharing",
            }


        ],
    },




    {
        id: 8,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Key Word Transformation",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo: "Key Word Transformation Simulation ", descripcion: "The final part of the Use of English paper is Key Word Transformations. A sentence followed by a key word and a second sentence which has a gap in it. A student has to use the key word to complete the second sentence so that it means the same as the first sentence.", url4: "http://learnibox.vercel.app/keysimulation", url2: "https://youtu.be/fNDbieMpL-s?si=2MP6qGMEikEqVPCT" },

            { titulo: "Ebook ", descripcion: "Versión digital v.001", url: "https://drive.google.com/file/d/12-I0FaAIz-w2-wjfV5s8TkbIEwwSZCIm/view?usp=sharing", url2: "https://youtu.be/Hdy-7Tnr6S0?si=RWUmRuDyslqwcJ8V" },

            { titulo: "Key Word Transformation ", descripcion: "The final part of the Use of English paper is Key Word Transformations. A sentence followed by a key word and a second sentence which has a gap in it. A student has to use the key word to complete the second sentence so that it means the same as the first sentence.", url: "https://drive.google.com/file/d/1fzxVyBLvMHRwzfHTGLgYapKOXasOXv0m/view?usp=sharing", url3: "https://drive.google.com/file/d/1SlBZ6S1G4Jk_fMSC9kPJRa_XY_GuJfRN/view?usp=sharing", url7: "http://learnibox.vercel.app/kwt" },
            { titulo: "50 Key Word Transformation DAY 01  ", url: "https://drive.google.com/file/d/1shC9iwswMYoymUEiJ8H1s8b9ngvp8gdB/view?usp=sharing", url2: "https://youtu.be/c-8ZhXBLThg" },
            { titulo: "50 Key Word Transformation DAY 02  ", url: "https://drive.google.com/file/d/1shC9iwswMYoymUEiJ8H1s8b9ngvp8gdB/view?usp=sharing", url2: "https://youtu.be/CxG4A-NPmfA" },
            { titulo: "Key Word Transformation Secrets", url: "https://drive.google.com/file/d/11XTF7rYH66kt5GauEs65M4zMiyfrOKAy/view?usp=sharing" },
            { titulo: "Presentación", url: "https://youtu.be/Hk1y2D9jbvQ" },
            { titulo: "50 Key Word Transformation ", url: "https://drive.google.com/file/d/1shC9iwswMYoymUEiJ8H1s8b9ngvp8gdB/view?usp=sharing" },

            { titulo: "Solución KWT 01 ", url: "https://youtu.be/muqLK--ykjg" },
            { titulo: "Test KWT 01 ", url: "https://drive.google.com/file/d/10cOoRCKkswKlwi2GOM4cvdOlWNBE-Hbx/view?usp=sharing" },
            { titulo: "Solución KWT 02 ", url: "https://drive.google.com/file/d/1VeU2a_peDOk2WMACF8anyG0GwLGZzOvM/view?usp=sharing", url2: "https://youtu.be/7wrY5gW_Xco" },
            { titulo: "Solución KWT 03 ", url: "https://drive.google.com/file/d/1meGXse7csULGWCCAAOkANu1ckqn_bg5o/view?usp=sharing", url2: "https://youtu.be/D11X4WGnhuU", },


            { titulo: "📚[pdf] Key Word Transformation 001 ", url: "https://drive.google.com/file/d/1fzxVyBLvMHRwzfHTGLgYapKOXasOXv0m/view?usp=sharing", url3: "https://drive.google.com/file/d/1cXjQsg8lVZghohRvTd1D5DLjgByRfnww/view?usp=sharing", url7: "http://learnibox.vercel.app/kwt" },
            { titulo: "📚[pdf] Key Word Transformation 002 ", url: "https://drive.google.com/file/d/1AytA61HbBmJgFLcXNEwEBHJQjVelp1T3/view?usp=sharing" },
            { titulo: "📚[pdf] Key Word Transformation 003 ", url: "https://drive.google.com/file/d/1Kx3tL5lWNxOaeJwuu5bKqhaML8fi9nb6/view?usp=sharing" },
            { titulo: "📚[pdf] Key Word Transformation 004 ", url: "https://drive.google.com/file/d/1CkMzAwGVkwxbkDaLMAIaxo_cs3o4KADY/view?usp=sharing" },
            { titulo: "📚[pdf] Key Word Transformation 005 ", url: "https://drive.google.com/file/d/1qDQx3HJZL9Vkm6vOC9a-m7vUkqw4HMRa/view?usp=sharing" },

            { titulo: "📚 Key Word Transformation 28 ", url: "https://drive.google.com/file/d/10ct8FrtXch8uWcAuVeXoOw0h9aRZMm3f/view?usp=sharing" },
            { titulo: "📚 Key Word Transformation 29 ", url: "https://drive.google.com/file/d/1pTn7jQaGDjGHZ6LjXOUDpTy5j86W73BZ/view?usp=sharing" },
            { titulo: "📚 Key Word Transformation 30 ", url: "https://drive.google.com/file/d/1is1Fl-t-3IUPB31eclX1E6JpyyESoqtY/view?usp=sharing" },
            { titulo: "📚 Key Word Transformation 31 ", url: "https://drive.google.com/file/d/10vJ82iasNVDoCWiUomoA_zyp_NilAknA/view?usp=sharing" },
            { titulo: "📚 Key Word Transformation 32 ", url: "https://drive.google.com/file/d/1-92IEBQQcqQwK3LxDdLYmiAw0zaD6WGp/view?usp=sharing" },

        ],
    },

    {
        id: 9,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",
        title: " Mastering Verbs",
        subtitle: "Basic Level",
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "Los Verbos Irregulares II ", url: "https://drive.google.com/file/d/1EhALfkVQb-G5ylK9qMc674zmh8LWd-kT/view?usp=share_link", },
            { titulo: "Irregular Verbs forms ", descripcion: "Practice this with more than 200 exercises", url: "https://drive.google.com/file/d/1RpV1uLe-A215sfP1S954zi2zQs_XDvDg/view?usp=share_link", url3: "https://drive.google.com/file/d/19PGRN6t6JF3TyYxYBCJOzAdKDWIIurX3/view?usp=sharing", url5: "https://learnibox.vercel.app/sixtytype" },

            { titulo: "Transitive and Intransitive Verbs", url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: " Gerunds and Infinitives Explanation", url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", url3: "https://drive.google.com/file/d/1ezv2iZSq1XyKjAdi8gye4qm8SzSvLEv8/view?usp=sharing", url7: "https://learnibox.vercel.app/sixtytype" },




        ],
    },




    {
        id: 11,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Prepositions in Use",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "Colocation with On ", descripcion: "Aprenderemos las colocaciones mas frecuentes", url: "https://drive.google.com/file/d/1bUfF1EATw-gkYy4_D5mw9y_zAnpQebIy/view?usp=sharing", url2: "https://youtu.be/G0FOLPlRx7g" },
            { titulo: "Preposition 01 ", descripcion: "Be go out of fashion/on the increase/on the news", url: "https://drive.google.com/file/d/11SMHLs54sJoIkQMaBcp_c4gN9q_rB-S8/view?usp=sharing", url2: "https://youtu.be/V0eF1Yx9OoU" },
            { titulo: "Preposition 02 ", descripcion: "In brief/be under the impression/by mistake", url: "https://drive.google.com/file/d/1AVgvB-leSksusal7IRaT1qE08CPDXNi6/view?usp=sharing", url2: "https://youtu.be/nATMol35GwY?si=OWkCVt1OPt0mlQIw" },
            { titulo: "Preposition 03 ", descripcion: "on-in time/ in honor of/under-over age", url: "https://drive.google.com/file/d/1w_Vnyj2nUHelXYMGrh_zzTlSu8P7fppy/view?usp=sharing", url2: "https://youtu.be/nATMol35GwY?si=OWkCVt1OPt0mlQIw" },

            { titulo: "📝Prepositions 01 ", url: "https://drive.google.com/file/d/1ybpVAlxfM2Zvqe8xxBOPVCfFVCgk-W9U/view?usp=sharing", url3: "https://drive.google.com/file/d/1Ye15MSe8T9DXkWr03eUSYvShLbE_UnGQ/view?usp=sharing", url5: "https://learnibox.vercel.app/enghelp" },
            { titulo: "📝Prepositions 02 ", url: "https://drive.google.com/file/d/1PlFqX6zlyiNyjqOlaYQka6IeDomq0e0E/view?usp=sharing" },
            { titulo: "📝Prepositions 03 ", url: "https://drive.google.com/file/d/1wDbMgx8z91WcmuY-6tF_aFLoRGhrXKd-/view?usp=sharing" },
            { titulo: "📝Prepositions 04", url: "https://drive.google.com/file/d/1UHVi7z-9D8Es-kCBqmooDYLDlfB5vBct/view?usp=sharing" },
            { titulo: "📝Prepositions 05 ", url: "https://drive.google.com/file/d/1ZqQgXsnezJZNDhCBA_3xO90IlsO3oN6o/view?usp=sharing" },

            { titulo: "📑Interested in vs Interested to.pdf ", url: "https://drive.google.com/file/d/1vbKk7R4t3Zq1Zsfkl-3F3DPyhU2NXzhe/view?usp=sharing" },
            { titulo: "📑Sorry to/about/for ", url: "https://drive.google.com/file/d/1BrzsIhSqoqY7IWbRVQtwsvWWzciozGzr/view?usp=sharing" },
            { titulo: "☠️ Exam Prepositions 01 ", url: "https://drive.google.com/file/d/1Nea8nudn5VaF3B7RodO-5nmZOYr0koq4/view?usp=sharing" },
            { titulo: "🔑 Exam Key Prepositions 01 ", url: "https://drive.google.com/file/d/1oTS5PeWp8RPWcBzx0pCypXuI1WmWnjlI/view?usp=sharing" },
            { titulo: "📚At, In, By ( the end)..", url: "https://drive.google.com/file/d/1agtpiCvGtERX_ee7wHpNaax0hU1OmXyp/view?usp=sharing" },
            { titulo: "📚count on - depend on - rely on", url: "https://drive.google.com/file/d/1DxZyMcb1NwXXbt_wIAbhPTiNFMuvAKG6/view?usp=sharing" },

            { titulo: "📚BY, IN, ON + ING", url: "https://drive.google.com/file/d/1VmZIuWIV0IXYDd1RGtIo7krxPcBPGLOF/view?usp=sharing" },
            { titulo: "📚for sale - on sale - in the sale", url: "https://drive.google.com/file/d/1X4c4ZKEORCzHHE1SC0RVPRuDwRdB-hwb/view?usp=sharing" },



        ],
    },
    {
        id: 12,
        thumbnail: "https://i.ibb.co/5WQ17W7D/file-Fg6-EG7bvr-Nig-Ee3-S7m-XCfd.png",

        title: "Writing",
        subtitle: "B2/C1",

        dateAdded: "B2",
        channel: "sdasd",
        description: "Aprende técnicas literarias avanzadas para enriquecer tu escritura y expresión creativa en inglés",
        enlaces: [
            { titulo: "Guía Completa para el Writing", url: "https://drive.google.com/file/d/1OgZ88ntg0_7aHZ-D6qD3lfIvFGjkHnzd/view?usp=sharing" },


            { titulo: "Mistakes in Writing ", url: "https://drive.google.com/file/d/1yiMC18Dxy5b5h-ve47g4SQT_wUOZ3yQX/view?usp=sharing" },

            {
                titulo: "📃 Article  B2 Model",
                url: "https://drive.google.com/file/d/1U8-YHSgp_xeZDvbmty19W-fevEden95O/view?usp=sharing",
            },
            {
                titulo: "📃 Report  B2 Model",
                url: "https://drive.google.com/file/d/1_z4lgav_LheAS_ep8UEw4qcoz1SnI-XT/view?usp=sharing",
            },
            {
                titulo: "📃 Email  B2 Model",
                url: "https://drive.google.com/file/d/14Sb5Q_2-XOevWNgGqLaWyBDHGF3iX-DG/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Essay  B2 Model",
                url: "https://drive.google.com/file/d/1shuKn4-Sgu3VW2SqO1Gbv4a3BNUjFWB0/view?usp=sharing",
            }, {
                titulo: "📃[pdf] Essay  B2 Model 2",
                url: "https://drive.google.com/file/d/1A3zKsg5My6XQlKxWRNiCoM_Jh5Wwepvp/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] C1 Template Essay 2025",
                url: "https://drive.google.com/file/d/1ELdPTtS6V33-pBtJr2uRSizlrfuCH4nB/view?usp=sharing",
            },
            {
                titulo: "📃[pdf]Useful Language",
                url: "https://drive.google.com/file/d/1gMBSe_vvMgQq-IkIQtpDydmpuKq_YiMa/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Amazing Template Essay 2025",
                url: "https://drive.google.com/file/d/1GTnhTS-RWFKpJ2Q9DRhBOxb-IqgjIjmZ/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Writing Templates",
                url: "https://docs.google.com/document/d/1ynAsrV2Uj-uR0qrCDzGvDw8I2sXYlzEg/edit?rtpof=true&sd=true",
            },
            {
                titulo: "📃[pdf] How to write an Essay",
                url: "https://docs.google.com/presentation/d/1ulmNP0wMeqUi-ZlMpg6ngsCi_jjX9nBn/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            }, {
                titulo: "📃[ppt] Advanced Transitions",
                url: "https://docs.google.com/presentation/d/1fGnuhWtExMKny18ZqasLeugnXi9cb9pU/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            }, {
                titulo: "📃[Inf] Writing Mistakes everyone makes",
                url: "https://drive.google.com/file/d/17vYjDTq69ecevpRtiD1mSOevKqFLrOSM/view?usp=sharing",
            },

        ],
    },


    {
        id: 10,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",
        title: "Passive Voice",
        subtitle: "Passive Voice",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "The Passive Voice in English", descripcion: "This comprehensive guide will show you exactly how to form and use the passive voice in all tenses, with clear explanations and practical examples.", url2: "https://youtu.be/wLfAGSGAbqs" },

            { titulo: "Passive Voice Quizz ", descripcion: "Practice this with more than 200 exercises", url: "https://youtu.be/Hk1y2D9jbvQ", url3: "https://drive.google.com/file/d/1eiZnSoOK7R8yvCZGyBtegOXcZwsmQTCS/view?usp=sharing", url5: "https://learnibox.vercel.app/sixtytype" },

            { titulo: "✍ PA001 - Passive Voice - Sentence Building", url: "https://drive.google.com/file/d/1dnTe8P1YghBdXX-241IbAgBwY4Q906_R/view?usp=sharing", },
            { titulo: "✍ PA006 - Passive Voice - Make sentences using the tenses in brackets ", url: "https://drive.google.com/file/d/12WGBkRNI1TTH3LYZiDrLCn0XjIWoeIbQ/view?usp=sharing", },
            { titulo: "✍ PA009 - Active and Passive Voice ", url: "https://drive.google.com/file/d/1hMKF8FFuuZJCcr8g-Uaky3fEdyRsj4B2/view?usp=sharing", },
            { titulo: "✍ PA015 - Verb Tenses - Active or Passive Voice ", url: "https://drive.google.com/file/d/1J0928j_2Em_fLeSLqpxOImWcfcCCQv2L/view?usp=sharing", },
            { titulo: "✍ PA016 - A Local Sports Centre - Passive Voice ", url: "https://drive.google.com/file/d/1UZQPDIEmqOl0POB7gzbSnZo0zO6W9vzo/view?usp=sharing", },


        ],
    },

    {
        id: 13,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",
        title: "Recursos Descargables",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo: "📒 Study Guide", url: "https://drive.google.com/file/d/1pKc3ccQW3ToLCZo3Hpl-t7AztxsMokMD/view?usp=sharing", url2: "https://youtu.be/Ge1WzZFQm9w" },

            { titulo: "English - Listening and speaking  B2", url: "https://drive.google.com/file/d/1WWS3zyzQlu_5Zkv0y9HqRJMT9CeQnkpl/view?usp=sharing" },
            { titulo: "Cambridge B2 ", url: "https://drive.google.com/file/d/1CU9wjKF6k91uq1vgXAiSPx9LQmIP9Gos/view?usp=sharing" },
            { titulo: "B2/C1 Vocabulary", url: "https://drive.google.com/file/d/1v46CdxreA1fd9G6L9bzttZrP2zEu5zs7/view?usp=sharing" },
            { titulo: "EngHelp", url: "https://drive.google.com/file/d/1v46CdxreA1fd9G6L9bzttZrP2zEu5zs7/view?usp=sharing" },
            { titulo: "Grammar Space", url: "https://drive.google.com/file/d/1v46CdxreA1fd9G6L9bzttZrP2zEu5zs7/view?usp=sharing" },

        ],
    },



    {
        id: 14,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Real English Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [

            { titulo: "Saxon genitive", url: "https://drive.google.com/file/d/1vRBsRnPMX_9m_wNUkAvs2phvuR8DYHqD/view?usp=sharing", url3: "https://drive.google.com/file/d/18PItis9izfn8oMa-2V91VTX3SQq9W2Tq/view?usp=sharing" },
            { titulo: "Saxon vs Of", url: "https://drive.google.com/file/d/1LeR_MDZFr_BJhZ3fu16vg6eUuvUQri3o/view?usp=sharing" },
            { titulo: "📚That's why - that's because.pdf", url: "https://drive.google.com/file/d/1-VKBz1cVT8zW1yZFf1QYGry984MX7BML/view?usp=sharing" },
            { titulo: "Solucionario Codigo", url: "https://drive.google.com/file/d/1h_GmZKkaqKgs3BGwUmpQWsf631u2MnFs/view?usp=sharing" },

            { titulo: "Examen Saxon genitive", url: "https://drive.google.com/file/d/1lauthcKfiGkFEhUQMq3hjpQlJAvBfl1n/view?usp=sharing" },
            { titulo: "Examen de Interpretacion", url: "https://drive.google.com/file/d/1ZlLgABkb88_3qDLHlrTYOpHCUCTouVbz/view?usp=sharing" },
            { titulo: "Vocabulary 01", url: "https://drive.google.com/file/d/17OdvZytOobwQmpNyA5boo4a7SUfBnJtC/view?usp=sharing", url3: "https://drive.google.com/file/d/1mre82d_iD2qyoDP9IG6nmGGNooLOnlK5/view?usp=sharing" },

            { titulo: "Obtener Codigo", url: "https://drive.google.com/file/d/1elKV4DgU5egBqau8EzDvYkub2OCfiORs/view?usp=sharing" },


        ],
    },
    {
        id: 15,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",
        title: "Real Grammar in use 02",
        subtitle: "B2/C1",

        dateAdded: "Week 01 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo: "📑 Verbs 01", url: "https://drive.google.com/file/d/12Kh_QqxgHwz6dT7Vos8XAh-sZzYbc4hZ/view?usp=sharing" },
            { titulo: "📚no good vs not good.pdf", url: "https://drive.google.com/file/d/1-5MHEN322Xi2xUYpDWYU115P2NXYQzdr/view?usp=sharing" },
            { titulo: "📚[ppt] Used to/ be used to / get used to   ", url: "https://drive.google.com/file/d/1t9c1CP7VuTePAYy00qC3r85qRNoBM-7v/view?usp=sharing" },
            { titulo: "📚MADE (OF, OUT OF, UP OF, FROM, WITH).pdf ", url: "https://drive.google.com/file/d/1-Mw6MXOBx3V6D0WvlN1l3Hn6XGBTrolK/view?usp=sharing" },
            { titulo: "📚CERTAINTY and Possibility.pdf ", url: "https://drive.google.com/file/d/1mm_5Vu6RvtWArxSLoK5sXT3cR5XVzWWJ/view?usp=sharing" },
            { titulo: "📚MORE vs ELSE.pdf ", url: "https://drive.google.com/file/d/1vcmTTeSYW8DsLahQRM_WCGG-PYdeRmET/view?usp=sharing" },
            { titulo: "📚MOST OF ALL...pdf ", url: "https://drive.google.com/file/d/1q9UddjPgJnivJ3jw1O4YUeFZQB38brVl/view?usp=sharing" },
            { titulo: "📚Neither + singular or plural..pdf ", url: "https://drive.google.com/file/d/1-Q9yKb-unyv3FAKZLhiU5nVrjc0-yu3x/view?usp=sharing" },
            { titulo: "📚Not only... but also...(structure)", url: "https://drive.google.com/file/d/1oXgZlGy5JdqxtVyzTQ-hiAfeyWadDkpG/view?usp=sharing" },
            { titulo: "Despite & In spite of", url: "https://drive.google.com/file/d/1Mz8VnETibHBD0ID3hanTfrNS66xHU6_h/view?usp=sharing" },
            { titulo: "Hope ", url: "https://drive.google.com/file/d/1TcYDUgDV2y6dJcIJRToStpzojqNYu0iB/view?usp=sharing" },
            { titulo: "Usual", descripcion: "Aprende los diferentes usos del usual", url: "https://drive.google.com/file/d/1Iru4Ttn7yf9vwOiUU8XjC6MCB9DPMHA8/view?usp=sharing", url2: "https://youtu.be/OSRAYauWH-I", url3: "https://drive.google.com/file/d/1sugjoNOr6dwEHogTwcKeYHUVbebEBbpX/view?usp=sharing" },
            { titulo: "Usually", url: "https://drive.google.com/file/d/1IPWIh1B7oYwV4aPRJJKnM-gpZICitsX_/view?usp=sharing", url2: "https://www.youtube.com/watch?v=nYxi8UCraJI&ab_channel=MyEnglishBro" },
            { titulo: "I think not vs I don't think so. ", url: "https://drive.google.com/file/d/15nnCB3JJRtH1fqqx5TypEptgoRbo5q-P/view?usp=sharing" },
            { titulo: "📚the same as - the same that.pdf", url: "https://drive.google.com/file/d/1XxkdYtKE6YyMH3jP93Aog9mXF_l9wu9l/view?usp=sharing" },
            { titulo: "Leave vs Forget", descripcion: "Diferencias en uso ", url: "https://drive.google.com/file/d/111yc2_YM2otUrY5Zd7x4XMEghsDeVhuq/view?usp=sharing", url2: "https://youtu.be/ZuTu0cKrgA4?si=SwLXrU0zQTyxjNDz", url3: "https://drive.google.com/file/d/1lATJkiV8vcDJ21Mu5jPDOjPRkyX_a5qZ/view?usp=sharing", url4: "https://learnibox.vercel.app/gspace", url5: "https://learnibox.vercel.app/enghelp", url6: "https://learnibox.vercel.app/xd" },
            { titulo: "Continuamente ", descripcion: "Diferencias en uso", url: "https://drive.google.com/file/d/1kENm-lqtM22jiVAej6_Io_IoYFeRDprC/view?usp=sharing", url2: "https://youtu.be/DXCOSUsATsE?si=KXNzdx8qbzOeCMkz", url3: "https://drive.google.com/file/d/17UWJLib-ZYETsEc-rF0p3byGvy24R_kY/view?usp=sharing" },
            { titulo: "Shout at vs Shout to", descripcion: "Diferencias en uso", url: "https://drive.google.com/file/d/1iisgsGHkBpj0nyGTvwxCiI8_aG3ukcsi/view?usp=sharing", url2: "https://youtu.be/QAJVD14o2a8" },
            { titulo: "Afraid ", descripcion: "Como usarlo", url: "https://drive.google.com/file/d/1X_G4Rvia8Lpu4C5MHXcLx7dXtUnfFsZb/view?usp=sharing" },
            { titulo: "Afraid to do vs Afraid of doing ", descripcion: "Diferencias claves", url: "https://drive.google.com/file/d/19XX67MnZ-Mf-rmq9pPlYm9GMogYOHQa_/view?usp=sharing", url2: "https://youtu.be/pYaZjZIQBdM", url3: "https://drive.google.com/file/d/1cCllRuslCkOJyqtgAhukNp_eGwN94zre/view?usp=sharing" },
            { titulo: " Encrucijada de Opciones ", descripcion: "Rather than, Instead of, As opposed to", url: "https://drive.google.com/file/d/13ZK9zCLBTKe73OQNaqvXjK-38ZvaJ8VT/view?usp=sharing", url3: "https://drive.google.com/file/d/1iqoLUXkRQqElYsf7faswD-xSfsSSuR9X/view?usp=sharing" },
            { titulo: " El Laberinto de la Prevención", descripcion: "Prevent, Stop, Avoid", url: "https://drive.google.com/file/d/1FoSc6244qwfBpG9EDxzX7YkHZTuk6EN8/view?usp=sharing" },
            { titulo: " El Reto de la Precisión", descripcion: "Differentiate, Distinguish, Discriminate", url: "https://drive.google.com/file/d/1v-uIHL_GseKjuslDEgVGhiTajGCL9CQs/view?usp=sharing" },
            { titulo: " Profecías del Futuro Cercano ", descripcion: "Immediate Future Expressions", url: "https://drive.google.com/file/d/1mOBysPhkjDIvx1ePzrM-LMnlrsGZuOzb/view?usp=sharing" },
            { titulo: "Rather than , Instead of . As opposed to", descripcion: "Continually, Continuously, Constantly", url: "https://drive.google.com/file/d/13ZK9zCLBTKe73OQNaqvXjK-38ZvaJ8VT/view?usp=sharing" },
            { titulo: " El Secreto del Buen Trabajo ", descripcion: "It's a good job /a good thing/just as well  that", url: "https://drive.google.com/file/d/1vHHH_2VXuIdDf_NSp6Ie9FgvHFB94G92/view?usp=sharing" },
            { titulo: "Chance of-Chance to... ", url: "https://drive.google.com/file/d/18otkt_PTLMwlZGqs4rBnXRMdhz48xUaS/view?usp=sharing" },
            { titulo: "feel like (doing) sth vs feel up to (doing) sth", url: "https://drive.google.com/file/d/1yVw8CbCu3FMAUYVJyKj42IoujDRxF1Iv/view?usp=sharing" },
            { titulo: "Wait ,Await, Expect ", url: "https://drive.google.com/file/d/1C1llJJ8yFX0i5pxSnTMUWPIjmNvISnHB/view?usp=sharing" },
            { titulo: "sidetrack - distract - put someone off", url: "https://drive.google.com/file/d/1uXbNu9yt24xuTIVk0u60JO0lxdxT9Wt8/view?usp=sharing" },
            { titulo: "sign vs signal", url: "https://drive.google.com/file/d/1HhFh07shRGd8N9LoKQtuSj21YBq2TCMV/view?usp=sharing" },
            { titulo: "Notice - realize - be aware", url: "https://drive.google.com/file/d/1ZUCrPpie-3e4GKFt5xuyqDXvdF4EwQ1P/view?usp=sharing" },
            { titulo: "Trust ,Distrust ,Entrust ", url: "https://drive.google.com/file/d/1gC2SLjM0tML-TVWLjl6a4V6wHYYkokbp/view?usp=sharing" },
            { titulo: "📚In the (short/medium /long) term / in the (short/long)run ", url: "https://drive.google.com/file/d/1OLnc9y-xWYZeoPXocHl4T0Hlow-W7-Jf/view?usp=sharing" },
        ],
    },


    {
        id: 16,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Connectives & Linking ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [

            { titulo: "📚[pdf] Connectives and Linking Phrases 001 ", url: "https://drive.google.com/file/d/1E-4DPNChktOiBETwI-npC9fPdRGotUqQ/view?usp=sharing" },
            { titulo: "📚[pdf] Connectives and Linking Phrases  002 ", url: "https://drive.google.com/file/d/1n3fWZPpV_DY9QCpUyvRqwO1wTMYZ67jA/view?usp=sharing" },
            { titulo: "📚[pdf] Connectives and Linking Phrases  003 ", url: "https://drive.google.com/file/d/1sxWll8fBOnh8JxQSUEYSF6ez4xqLhe3F/view?usp=sharing" },
            { titulo: "📚[pdf] Connectives and Linking Phrases  004 ", url: "https://drive.google.com/file/d/1nREywm6HXbce0qeVlH_kkcTV-DIAEtJI/view?usp=sharing" },


        ],
    },


    {
        id: 17,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",
        title: "B2 Bootcamp ",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida


        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [

            { "titulo": "B2 first Essential", "url": "https://www.youtube.com/watch?v=gGWtrDuoUi0" },
            { "titulo": " day 2", "url": "https://www.youtube.com/watch?si=MHjaEN7bzBy3ZOhc&v=9bB9PgyB_bg&feature=youtu.be" },
            { "titulo": " after", "url": "https://www.youtube.com/watch?v=5ilyP5xsyes&feature=youtu.be" },
            { "titulo": " day 3", "url": "https://www.youtube.com/watch?si=m4xdSF6v23GibP_H&v=CR6rnB5Yg0Y&feature=youtu.be" },
            { "titulo": " day 4", "url": "https://www.youtube.com/watch?si=tixxZisScjmyyLzI&v=eOtsLBuwvgw&feature=youtu.be" },
            { "titulo": "day 5", "url": "https://www.youtube.com/watch?si=dYFzG1VF98Tqkvyi&v=I5E5Q3yByPs&feature=youtu.be" },
            { "titulo": "  day 6", "url": "https://www.youtube.com/watch?si=-KYzJRc2XtTsfytL&v=OuqZlRsw7NE&feature=youtu.be" },
            { "titulo": " day 7", "url": "https://www.youtube.com/watch?v=4hyP05BgB9M&list=PLaYNhMsVRuHhY6xcwxg931ib5xCbw2zWC&index=8&ab_channel=MyEnglishBro" },
            { "titulo": " day 8", "url": "https://www.youtube.com/watch?v=XE7dOWDGpek&ab_channel=MyEnglishBro" },
            { "titulo": "day 9", "url": "https://www.youtube.com/watch?v=w2i-Q7YHpvc" },
            { "titulo": " day 10", "url": "https://youtu.be/1yYDsB_X9Ow" },
            { "titulo": " day 11", "url": "https://www.youtube.com/watch?v=G7noYDWA80I&ab_channel=MyEnglishBro" },
            { "titulo": " day 12", "url": "https://youtu.be/96wYFY3lUh4" },
            { "titulo": " day 13", "url": "https://www.youtube.com/watch?v=tVZPNUMq2d0&ab_channel=MyEnglishBro" },
            { "titulo": " day 14", "url": "https://www.youtube.com/watch?v=RAY0LxAjNOk&ab_channel=MyEnglishBro" },
            { "titulo": " day 15", "url": "https://www.youtube.com/watch?v=Czy1TEgGXu4&ab_channel=MyEnglishBro" },
            { "titulo": " day 16", "url": "https://www.youtube.com/watch?v=NZjOZDjhK3E" },
            { "titulo": "  day 17", "url": "https://www.youtube.com/watch?v=gpbEMX4KPk8" },
            { "titulo": "  day 18", "url": "https://www.youtube.com/watch?v=ez9eoYxzU-A&ab_channel=MyEnglishBro" },
            { "titulo": "  day 19", "url": "https://youtu.be/t1njSOFuS84" },
            { "titulo": "  day 20", "url": "https://youtu.be/oNkeUNBrjG0" },
            { "titulo": "  day 21", "url": "https://youtu.be/MdL2xj330bk" },
            { "titulo": " day 22", "url": "https://youtu.be/LYrMkpMS5RY" },
            { "titulo": "  day 23", "url": "https://youtu.be/iYdTP-7wvzc" },
            { "titulo": "  day 24", "url": "https://youtu.be/esjEITmf8Ug" },
            { "titulo": "  day 25", "url": "https://youtu.be/OxXnEdw-LdU" }
        ],

    },

    {
        id: 18,
        thumbnail: "https://i.ibb.co/RTGW1WxL/newback.png",


        title: "B2 First 2024",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
            { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=R2TVluocgUg&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=5&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=kLjAWxOYZDI&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=_FJtW3NHYxQ&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=2&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=uSoQGya3n_Y&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=3&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=ccyWNJz7FS4&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=4&ab_channel=MyEnglishBro" },

        ],

    },
    {
        id: 19,
        thumbnail: "https://i.ibb.co/fdvHb0wg/file-Fg-Ck-CXPth2-Nv-VVv4mnbaiq.png",

        title: "IELTS Band 5",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
            { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=nIZcH0sQSf0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=1&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=C0RB86t1YIw&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=2&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=TV10GT7j_es&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=3&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=2ExYgxh9gjE&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=5&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=UEEEwLpO7z0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=4&ab_channel=MyEnglishBro" },

        ],

    },




    {
        id: 20,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Essential Grammar ",
        subtitle: "B2",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [


            { titulo: "📚[Slide] Impersonal Passive/ Personal Passive  ", url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view" },

            { titulo: "📚Amount ..Quantity ..Number  ", url: "https://drive.google.com/file/d/1CN4FalpOZBZ-SMMcatuxD_uasMzenrDA/view?usp=sharing" },
            { titulo: "📚apart from, aside from, except for  ", url: "https://drive.google.com/file/d/1EEftSd6UjyKcnVoP77VJFglfxUw_7gng/view?usp=sharing" },
            { titulo: "📚Aren't I vs Am I not ", url: "https://drive.google.com/file/d/1DKuTnhQurzBMHVo0P0GLL_EdI3y8LMvs/view?usp=sharing" },
            { titulo: "📚AS...AS... vs NOT SO...AS..", url: "https://drive.google.com/file/d/1VLCJlD5Tgn9XU3oUo05emwf23WkT5XQ8/view?usp=sharing" },
            { titulo: "📚Future Plans- be going to vs present continuous", url: "https://drive.google.com/file/d/1Ov96Gz7ZEr3wDsnwDXF15q-6C8TrAPts/view?usp=sharing" },
            { titulo: "📚by the time (that), by now, by then.", url: "https://drive.google.com/file/d/1VQxnXCmbei5cxZucSW8FJKBOdgMQGRmO/view?usp=sharing" },
            { titulo: "📚cannot vs can not", url: "https://drive.google.com/file/d/1CXcCzrtdDif6iBEi75d_9CFxIE6847Q4/view?usp=sharing" },
            { titulo: "📚CAUSATIVE VERBS (have - get) ", url: "https://drive.google.com/file/d/1-PErCarKwe61HtSAbgx2wtJapHkBM9bp/view?usp=sharing" },
            { titulo: "📚Table CAUSATIVE VERBS (have - get) ", url: "https://drive.google.com/file/d/1NoE0tUIpAlHgGNHc1xBIi_YFIyoBax15/view?usp=sharing" },
            { titulo: "📚Consist in vs Consist of.. ", url: "https://drive.google.com/file/d/1F-XK5pIbsWwlOIDU-XfXpEVATQdlTggq/view?usp=sharing" },
            { titulo: "📚CORRELATIVE CONJUNCTIONS", url: "https://drive.google.com/file/d/16ud5EPb-q127g3tRlHKoV_Pk5HKpLoh8/view?usp=sharing" },
            { titulo: "📚DECISIONS, PLANS, PREDICTIONS", url: "https://drive.google.com/file/d/1LirHWCiSSatbjAv8q1ItdX32fnY2Tk8c/view?usp=sharing" },
            { titulo: "📚didn't need to vs needn't have done..", url: "https://drive.google.com/file/d/134MeLLR89v9--eCmh35fZ7FnQsbra8lT/view?usp=sharing" },
            { titulo: "📚Direct & Indirect speech (table) + kwt exercises", url: "https://drive.google.com/file/d/1rBQWS8z17BGn4B2mT0SGJt6J5CHEyZkw/view?usp=sharing" },
            { titulo: "📚do you mind  would you mind", url: "https://drive.google.com/file/d/1qUomEVgJdczYHV59Z_JCNTCSfQZ0Md9W/view?usp=sharing" },
            { titulo: "📚Early vs Soon ", url: "https://drive.google.com/file/d/1Acdy7DKjKxgj_6sWY4adIxRH9u5v-6bj/view?usp=sharing" },
            { titulo: "📚Either ...or  vs OR ", url: "https://drive.google.com/file/d/1DD4Z1gKhaIB3WK1wBB2aH1gk1bVglPhI/view?usp=sharing" },
            { titulo: "📚EVEN though-when-if-so ", url: "https://drive.google.com/file/d/1K5b3KQrgOSpO_5gfqRTbf7UEVFHuGrob/view?usp=sharing" },
            { titulo: "📚WHAT and HOW (Exclamations) ", url: "https://drive.google.com/file/d/1OJI6_nCQEgh26dLzcN0Lta-I5Ln202Oq/view?usp=sharing" },
            { titulo: "📚Expressing lack of surprise (phrases).. ", url: "https://drive.google.com/file/d/10OCN5p9pht9TviKo5C8Tlpq65n7LFSzV/view?usp=sharing" },
            { titulo: "📚EXPRESSING PURPOSE-- ", url: "https://drive.google.com/file/d/1aRymKDEhwoQRppVdi-ztAThEOAOp0JMe/view?usp=sharing" },
            { titulo: "📚Expressing willingness (Will and Would ) ", url: "https://drive.google.com/file/d/1AJr_SKwGzajEuvqdC72Mumc0DVJZwag0/view?usp=sharing" },
            { titulo: "📚Few vs Little Full Explanation", url: "https://drive.google.com/file/d/1aBJdWZnhLdBVlvxlBl3hb_-0tac67XUw/view?usp=sharing" },
            { titulo: "📚FOR + ING vs TO+ INFINITIVE", url: "https://drive.google.com/file/d/1rX-n7tp2oviaCzq6QjiSlBe4jZlTW2y5/view?usp=sharing" },
            { titulo: "📚FOR...TO", url: "https://drive.google.com/file/d/17TmzNhbfrrhN344SE_TnKDMo0Jip1-b5/view?usp=sharing" },
            { titulo: "📚FUTURE CONTINUOUS", url: "https://drive.google.com/file/d/1CHKDeg9dOgpCRuGliPUKMI0vUI-ccZlK/view?usp=sharing" },
            { titulo: "📚had better", url: "https://drive.google.com/file/d/1HJEWIQQrKUc3ZeI0tQUVOz9Uq3ooXY6_/view?usp=sharing" },
            { titulo: "📚having a lot to do", url: "https://drive.google.com/file/d/1LiGCvmom_wRtwvNbKXx3WhALIglfBsgS/view?usp=sharing" },
            { titulo: "📚I wish he were vs I wish he was. ", url: "https://drive.google.com/file/d/1fbiunfDO3ATtUfhVjJmYTVaiIl7wuHUM/view?usp=sharing" },
            { titulo: "📚wish you didn't - wish you wouldn't", url: "https://drive.google.com/file/d/1c_W6Rnvb2guEvvGvtz4UpXOXt-oowWLm/view?usp=sharing" },
            { titulo: "📚If I were vs If I was ", url: "https://drive.google.com/file/d/1L8gL4in7HNGsjw_fqgsCzi2FPNi3VYR8/view?usp=sharing" },

            { titulo: "📚INCLUDING OR OMITTING RELATIVE PRONOUNS ", url: "https://drive.google.com/file/d/1Ewn06vQoRRM7-ObSlsWbRMMgY937yU6o/view?usp=sharing" },
            { titulo: "📚INVERSIONS AT B2 LEVEL..pdf ", url: "https://drive.google.com/file/d/17DCJanovoUIB6Vome6kfXe4kMRVo24Cc/view?usp=sharing" },
            { titulo: "📚INVERSION - NEITHER and NOR..pdf ", url: "https://drive.google.com/file/d/1WPJd9-AcEd7p7uvD6IMT1LLVgh0c6JrO/view?usp=sharing" },
            { titulo: "📚Irregular verbs that stay the same.pdf ", url: "https://drive.google.com/file/d/1lXnJki--FsJONo7pe-kcyTrP_ULPrPGq/view?usp=sharing" },
            { titulo: "📚it's (about-high) time ", url: "https://drive.google.com/file/d/1JsV99-95VmCWYE-ueZxQOT-2X7G8F-WJ/view?usp=sharing" },
            { titulo: "📚it is you who is or are.pdf ", url: "https://drive.google.com/file/d/1BndKeJOOstmHCB7pUYxQQyLr-YhfcSPJ/view?usp=sharing" },
            { titulo: "📚JOINING NEGATIVE IDEAS.pdf ", url: "https://drive.google.com/file/d/1OuDSE00YChqB4_W8nCFT7R2DTWt5ZfLF/view?usp=sharing" },










            { titulo: "📚Personal and Impersonal Passive", url: "https://drive.google.com/file/d/1obtVtl8UEAVz9UCz4aff_q7WGGYwDim2/view?usp=sharing" },
            { titulo: "📚PREFER (structures)", url: "https://drive.google.com/file/d/1K1snnmMtNgzLZOuyZ5HQR62_5MWh4_kt/view?usp=sharing" },
            { titulo: "📚Prepare for, Prepare oneself for", url: "https://drive.google.com/file/d/1tG9gKZJ_jzgMHZZC2H5oqGvrf78UxRCU/view?usp=sharing" },
            { titulo: "📚present habits", url: "https://drive.google.com/file/d/1qoaInxhVWNQsxI354IL8Cj3ho7iHjCQ7/view?usp=sharing" },


            { titulo: "📚QUANTIFIERS", url: "https://drive.google.com/file/d/1iGVwAqosK0wGZ216J_rgHXVnuVnLBZLM/view?usp=sharing" },
            { titulo: "📚Universal Tags", url: "https://drive.google.com/file/d/1N2ZdcMbCQ_JEZEgXXsZ7QEjyhjgN2sjY/view?usp=sharing" },
            { titulo: "📚QUESTION TAG - HAVE", url: "https://drive.google.com/file/d/1TfK9qlZtV5D3m1PFQ98IpYTLV8G9RSTM/view?usp=sharing" },



            { titulo: "📚statement tags", url: "https://drive.google.com/file/d/1wPLJc7cxDP6KjIphJKOf5yDgy6PKGqQA/view?usp=sharing" },





            { titulo: "📚Words with Silent Letters", url: "https://drive.google.com/file/d/1eAPZFyNImLFcuMVSfvWhfJgUPj4f78jO/view?usp=sharing" },
            { titulo: "📚SINGULAR THEY", url: "https://drive.google.com/file/d/1xAT_pnOmVjImRxmr1LX57yWLdWbKGVf4/view?usp=sharing" },
            { titulo: "📚so+adj+that vs so+adj+as to", url: "https://drive.google.com/file/d/1Dox44XMlIjIJkzhUO1-wjetHjtfbn13Q/view?usp=sharing" },

            { titulo: "📚take for, mistake for, confuse with", url: "https://drive.google.com/file/d/19Vprq7R-KXX0JVHNjK5p9et5eLlAduJ-/view?usp=sharing" },






            { titulo: "📚Universal Tags--.pdf", url: "https://drive.google.com/file/d/1OSz1iN5iCyX05MS1x0HLVUt93kuQUKKa/view?usp=sharing" },
            { titulo: "📚[Slide] Useful Homophones ", url: "https://drive.google.com/file/d/1MWO2XHuHp0bAzFceREIteP_cKXyuwe1j/view?usp=sharing" },
            { titulo: "📚Verbs followed by infinitive or gerund with change in meaning ", url: "https://drive.google.com/file/d/1-zILhE9-k1jSvyi5Rx5u6G_mRR_cpXxa/view?usp=sharing" },
            { titulo: "📚IF vs WHETHER.pdf", url: "https://drive.google.com/file/d/1K8SHYnfmfuU7V8MBw2IGBot7wk1VO0hb/view?usp=sharing" },
            { titulo: "📚[Slide] Would rather/Would Sooner ", url: "https://drive.google.com/file/d/1F-t7qwMfcb5PDKfFodN02qZFwCzIZFqu/view?usp=sharing" },
            { titulo: "📚You and me vs You and I.pdf", url: "https://drive.google.com/file/d/1HQvOU9nI4uYstFx3AndBDY2Krj7C1cso/view?usp=sharing" },
            { titulo: "📚Zero article vs definite article (locations).pdf", url: "https://drive.google.com/file/d/1C1ia0DWTYVI0wI-aZS3CGf2oEuLwmwyk/view?usp=sharing" },

        ],
    },



    {
        id: 21,
        thumbnail: "https://i.ibb.co/vCS8bknP/DALL-E-2025-03-14-10-37-22-A-formidable-warrior-representing-the-challenge-of-mastering-English-voca.webp",

        title: "Vocabulary",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "List 01", url: "https://drive.google.com/file/d/1eGDk_XRymJiQx1EQdQ1VrrD-g-LKqAtT/view?usp=sharing" },
            { titulo: "List 02", url: "https://drive.google.com/file/d/1p3CZYooGPIALtdYjYo6VgInqBclmhh3m/view?usp=sharing" },
            { titulo: "List 03", url: "https://drive.google.com/file/d/1p29O7AwJXBxjKOR8CeRaeNTpISGO6-TC/view?usp=sharing" },
            { titulo: "List 04", url: "https://drive.google.com/file/d/16BMsrHXCXLo3A2pHD3_B8e5_aI5BdU_l/view?usp=sharing" },
            { titulo: "List 05", url: "https://drive.google.com/file/d/14Zc_IKDm1_Up-ByUsJH8fHWZRVEWMTYj/view?usp=sharing" },


        ],
    },

    {
        id: 22,
        thumbnail: "https://i.ibb.co/chjzRzhM/DALL-E-2025-03-03-10-26-54-A-high-quality-digital-illustration-of-a-young-warrior-student-advancing.webp",

        title: "Week 02",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "However vs Nevertheless  ", url: "https://drive.google.com/file/d/17HG1wBQ5zHdOzYjHMGitv20kmvUm4cQ3/view?usp=sharing" },
            { titulo: "However vs Nevertheless 2  ", url: "https://drive.google.com/file/d/1Lg28Wbr5irTlfxbhDk-NQdQJf24Y0Tgz/view?usp=sharing" },

            { titulo: "on the one / other hand  ", url: "https://drive.google.com/file/d/1dB853cQmDq5i5K708OZKgwwO0_rEBaPQ/view?usp=sharing" },
            { titulo: "When it comes to   ", url: "https://drive.google.com/file/d/1lHB4gZng8Xl_ZCHbHyILcPI-yzbH_ErB/view?usp=sharing" },
            { titulo: "to what extent  ", url: "https://drive.google.com/file/d/1RMz56tFmTkfh08F8dWitdr0mT47hWP-e/view?usp=sharing" },

            { titulo: "📚already/still/yet  ", url: "https://drive.google.com/file/d/126LmouA8outgNhw5x6wUcZI3F4tT1v4j/view?usp=sharing" },

            { titulo: "📚Among vs Between", url: "https://drive.google.com/file/d/1cpk7V_8qdxoX8VUpZYRT5zq_9GrCoWzc/view?usp=sharing", url3: "https://drive.google.com/file/d/1oL-Hu8nnXahjVI0gUZlN7YZWqVw5bkBC/view?usp=sharing" },

            { titulo: "📚between you and me vs between you and I", url: "https://drive.google.com/file/d/1cpk7V_8qdxoX8VUpZYRT5zq_9GrCoWzc/view?usp=sharing", url3: "https://drive.google.com/file/d/1oL-Hu8nnXahjVI0gUZlN7YZWqVw5bkBC/view?usp=sharing" },
            { titulo: " Common Binomials", url: "https://drive.google.com/file/d/1LgAKdAj0ftr1PIN46d4aAdBLuiyEdaPl/view?usp=sharing", url3: "https://drive.google.com/file/d/1Tg8SJHCNLodO3LwoMm8Y0qepMvDzUNMh/view?usp=sharing" },
            { titulo: "Be up TO & FOR", url: "https://drive.google.com/file/d/1xzD1SJQbZJ1aAxkM0jljNOAE2tPD_FYz/view?usp=sharing" },
        ],
    },

    {
        id: 24,
        thumbnail: "https://i.ibb.co/C3pnhgt6/file-N3-Gw1-XXR7w-Wr-Wom-Bj-Xy-Mgg.png",
        title: "IELTS Band 6 ",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [

            { "titulo": "[🖥️Class]  day 10", "url": "https://youtu.be/vOFnYJj2YDw?si=97D43xFvTa5T62Ki" },
            { "titulo": "[🖥️Class]  day 09", "url": "https://youtu.be/b6djjYxzL2E?si=oi_jE9U0HIGCTQPO" },
            { "titulo": "[🖥️Class]  DAY 07-08", "url": "https://youtu.be/1mtFYWdDKRk?si=-AYtTZEFO5J6cde0" },
            { "titulo": "[🖥️Class]  day 6", "url": "https://youtu.be/QCqUi-A0aFo?si=Nq1-DkvbDPf-5kzW" },

            { "titulo": "[🖥️Class]  day 3-4-5", "url": "https://youtu.be/0j8cXsFRvjU?si=qspyfEdp9ckn4KA4" },
            { "titulo": "[🖥️Class]  day 1", "url": "https://youtu.be/e413NPHCLzk?si=qMuNrow1upMvf3Xz" },


        ],

    },


    {
        id: 25,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",
        title: "Recordings 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [

            { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=gGWtrDuoUi0" },
            { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?si=MHjaEN7bzBy3ZOhc&v=9bB9PgyB_bg&feature=youtu.be" },
            { "titulo": "[🖥️Class]  after", "url": "https://www.youtube.com/watch?v=5ilyP5xsyes&feature=youtu.be" },
            { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?si=m4xdSF6v23GibP_H&v=CR6rnB5Yg0Y&feature=youtu.be" },
            { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?si=tixxZisScjmyyLzI&v=eOtsLBuwvgw&feature=youtu.be" },
            { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?si=dYFzG1VF98Tqkvyi&v=I5E5Q3yByPs&feature=youtu.be" },
            { "titulo": "[🖥️Class]  day 6", "url": "https://www.youtube.com/watch?si=-KYzJRc2XtTsfytL&v=OuqZlRsw7NE&feature=youtu.be" },
            { "titulo": "[🖥️Class]  day 7", "url": "https://www.youtube.com/watch?v=4hyP05BgB9M&list=PLaYNhMsVRuHhY6xcwxg931ib5xCbw2zWC&index=8&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 8", "url": "https://www.youtube.com/watch?v=XE7dOWDGpek&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 9", "url": "https://www.youtube.com/watch?v=w2i-Q7YHpvc" },
            { "titulo": "[🖥️Class]  day 10", "url": "https://youtu.be/1yYDsB_X9Ow" },
            { "titulo": "[🖥️Class]  day 11", "url": "https://www.youtube.com/watch?v=G7noYDWA80I&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 12", "url": "https://youtu.be/96wYFY3lUh4" },
            { "titulo": "[🖥️Class]  day 13", "url": "https://www.youtube.com/watch?v=tVZPNUMq2d0&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 14", "url": "https://www.youtube.com/watch?v=RAY0LxAjNOk&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 15", "url": "https://www.youtube.com/watch?v=Czy1TEgGXu4&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 16", "url": "https://www.youtube.com/watch?v=NZjOZDjhK3E" },
            { "titulo": "[🖥️Class]  day 17", "url": "https://www.youtube.com/watch?v=gpbEMX4KPk8" },
            { "titulo": "[🖥️Class]  day 18", "url": "https://www.youtube.com/watch?v=ez9eoYxzU-A&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 19", "url": "https://youtu.be/t1njSOFuS84" },
            { "titulo": "[🖥️Class]  day 20", "url": "https://youtu.be/oNkeUNBrjG0" },
            { "titulo": "[🖥️Class]  day 21", "url": "https://youtu.be/MdL2xj330bk" },
            { "titulo": "[🖥️Class]  day 22", "url": "https://youtu.be/LYrMkpMS5RY" },
            { "titulo": "[🖥️Class]  day 23", "url": "https://youtu.be/iYdTP-7wvzc" },
            { "titulo": "[🖥️Class]  day 24", "url": "https://youtu.be/esjEITmf8Ug" },
            { "titulo": "[🖥️Class]  day 25", "url": "https://youtu.be/OxXnEdw-LdU" }
        ],

    },
    {
        id: 26,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",


        title: "Recordings 2025",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
            { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=R2TVluocgUg&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=5&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=kLjAWxOYZDI&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=_FJtW3NHYxQ&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=2&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=uSoQGya3n_Y&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=3&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=ccyWNJz7FS4&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=4&ab_channel=MyEnglishBro" },

        ],

    },
    {
        id: 27,
        thumbnail: "https://i.ibb.co/PGdF1Pw/Dise-o-sin-t-tulo-7.png",

        title: "Recording IELTS 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
            { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=nIZcH0sQSf0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=1&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=C0RB86t1YIw&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=2&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=TV10GT7j_es&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=3&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=2ExYgxh9gjE&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=5&ab_channel=MyEnglishBro" },
            { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=UEEEwLpO7z0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=4&ab_channel=MyEnglishBro" },

        ],

    },
    {
        id: 28,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: " English Expressions",
        subtitle: "B2/C1",
        color: "#D6083B", 
        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [

            { "titulo": "Turn the Tables", "url": "https://www.youtube.com/watch?v=3BP1kSUR1f0&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&ab_channel=MyEnglishBro" },
            { "titulo": "Watch your Mouth", "url": "https://www.youtube.com/watch?v=_eriRuRfvvM&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=2&ab_channel=MyEnglishBro" },
            { "titulo": "Spreading Rumors", "url": "https://www.youtube.com/watch?v=or0ZxUll78g&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=3&ab_channel=MyEnglishBro" },
            { "titulo": "Yo me lo busqué", "url": "https://www.youtube.com/watch?v=lcmn32R7u4k&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=4&ab_channel=MyEnglishBro" },
            { "titulo": "Agarrarle el ritmo", "url": "https://www.youtube.com/watch?v=hHITyx_4An8&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=5&ab_channel=MyEnglishBro" },
            { "titulo": "Empezar con el Pie Izquierdo", "url": "https://www.youtube.com/watch?v=oDkLrT8xRkg&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=6&ab_channel=MyEnglishBro" },

        ],

    },







    {
        id: 31,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [


            { titulo: "📒[slides] Relative Clauses Explanation", url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing", },

            { titulo: "📒[slides] Defining Relative Clauses Exercise 1", url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing", },
            { titulo: "🔑 Defining Relative Clauses Exercise 1 key", url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing", },

            { titulo: "📒[slides] Defining Relative Clauses Exercise 2", url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing", },
            { titulo: "🔑 Defining Relative Clauses Exercise 2 key", url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing", },

            { titulo: "📒[slides] Defining Relative Clauses Exercise 3", url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing", },
            { titulo: "🔑 Defining Relative Clauses Exercise 3 key", url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing", },

            { titulo: "📒[slides] Defining Relative Clauses Exercise 4", url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing", },
            { titulo: "🔑 Defining Relative Clauses Exercise 4 key", url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing", },
            { titulo: "[Grammar Worksheet] WHO 1 ", url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing", },
            { titulo: "[Grammar Worksheet] WHO 2 ", url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing", },

            { titulo: "[Grammar Worksheet] WHOSE", url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing", },

            { titulo: "[Grammar Quizz] Relative Clauses", url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing", },
            { titulo: "[Grammar Quizz] WHO vs WHOSE", url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing", },
            { titulo: "RC001 - Relative Clauses", url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing", },
            { titulo: "RC002 - Relative Clauses - Combine the TWO Sentences", url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing", },
            { titulo: "RC003 - Relative Clauses - Combine the TWO Sentences", url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing", },
            { titulo: "RC004 - Relative Pronouns", url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing", },
            { titulo: "RC005 - Relative Clauses - Combine the TWO Sentences", url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing", },





        ],
    },





    {
        id: 32,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Building Vocabulary",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            { titulo: "📑 [Flash Cards] Fce Essential Words ", url: "https://quizlet.com/109647789/fce-vocabulary-flash-cards/?i=2oqoxh&x=1jqt" },
            { titulo: "📑 [Game] Fce B2 First Prepositions ", url: "https://wordwall.net/play/39433/169/368" },

            { titulo: "📑 [Anki Words] Necessary Words for Cambridge Exams ", url: "https://drive.google.com/file/d/1Nyh8Zhw0XGYZg-vFrNqpUT4oqNC0LozD/view" },
            { titulo: "📑 [PDF] List of 200 Phrasal Verbs | B2 First (FCE) ", url: "https://docs.google.com/document/d/1kUtVFcyPfupiE32q77xJwfQ1afTjWB6nm39tZsNDoxI/edit" },
            { titulo: "📑 [PDF] Collocation 01 | B2 First (FCE|CAE) ", url: "https://drive.google.com/file/d/1dFsaNG_Ln6tt29-fHuf-L22ktIRxnBjf/view?usp=sharing" },
            { titulo: "📑 [App] Dictionary ", url: "https://www.mediafire.com/file/zofkpkpcylqtpfp/MacMillanED_2nd_Edition.rar/file" },
            { titulo: "📑 [PDF] Answer Sheet ", url: "https://drive.google.com/file/d/16srt09bwR_CaPRNKel7WfErJSVqTyXl4/view?usp=sharing" },

            { titulo: "📑 [PDF] Prepositions After Verbs & Adjectives ", url: "https://docs.google.com/document/d/1CeVFrtcUUUYYfBOyHIvXkZ0mUjl3vx7ri-L0BYkARd8/edit#heading=h.te6z9i49xc6a" },

        ],
    },
    {
        id: 33,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Inglés con Anime",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            { titulo: "🎥[Video] Aprende inglés con Dragon Ball Z - Conversaciones ", url: "https://drive.google.com/file/d/1wBA_z3emPwA8_7zG4PTh_3eM9kIrsw_G/view?usp=sharing" },
            { titulo: "🎥[Video]  Picoro entrena a Gohan ", url: "https://drive.google.com/file/d/1cSJBlQ_0_N-hLgm4A-g-wNnv9U9x1lJZ/view?usp=sharing" },
            { titulo: "🎥 [Video] Ingles con Naruto ", url: "https://drive.google.com/file/d/1olidUMObF_HhIZ0BMJGQrRpZERjm-euc/view?usp=sharing" },
            { titulo: "🎥 [Video] El sacrificio de Vegeta ", url: "https://youtu.be/ce1JkqjXKJ4" },
            { titulo: "🎥 [Video] Useful Expressions Death Note ", url: "https://youtu.be/MTaLzZikzv4" },
            { titulo: "🎥 [Video] Useful Expressions One Punch Man ", url: "https://youtu.be/n_DcqiFayc4" },
            { titulo: "🎥 [Video] La fusion de Vegito ", url: "https://youtu.be/ma7q6esT3cg" },
            { titulo: "🎥 [Video] Useful Expression My hero Academy ", url: "https://youtu.be/8sPqgQlfKsQ" },
            { titulo: "🎥 [Video] Useful Expression Goku enseña la tecnica de la Fusion ", url: "https://youtu.be/S5yooa_kHDY" },


        ],
    }, {
        id: 34,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "If-Clauses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ IF001 - IF-Clauses - All Types ", url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ", url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ", url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ", url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ", url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ", url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ", url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ", url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ", url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ", url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ", url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },




        ],
    },
    {
        id: 35,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "TOEFL - Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Modal Verbs ", url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },

            { titulo: "✍ Comparatives & Modifiers  ", url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },
            { titulo: "✍ Comparatives & Modifiers II  ", url: "https://drive.google.com/file/d/1XFgGX1sdYUdhvYpKfK4e_Cqj_mQOie3-/view?usp=sharing", },
            { titulo: "✍ Comparatives & Modifiers III  ", url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },
            { titulo: "✍ Connectors  ", url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },
            { titulo: "✍ Correct Sentence Multiple Choice  ", url: "https://drive.google.com/file/d/1fDfIVqWLrLhqVHo-U1WMzsYqzgQ8M1Tr/view?usp=sharing", },

            { titulo: "✍ Parallel Structures ", url: "https://drive.google.com/file/d/1pTDJGKjUyVQSG6tEne2HdTIcdu96LDuE/view?usp=sharing", },

            { titulo: "✍Word Choice 1  ", url: "https://drive.google.com/file/d/1QBCWjTJ69eYmnp5LjxD32_sHESeUf2PT/view?usp=sharing", },
            { titulo: "✍Word Choice 2  ", url: "https://drive.google.com/file/d/11AcnwZ85R7GsoaU0kGKzYwV7wAzadRQ0/view?usp=sharing", },
            { titulo: "✍Word Choice 3  ", url: "https://drive.google.com/file/d/1mYW1BkrSOc_JDU0e-bH2w6-S5MwBg6LV/view?usp=sharing", },
            { titulo: "✍Word Choice 4  ", url: "https://drive.google.com/file/d/15BawZ93O21V7AC3mR_4sW29hzftMdMNd/view?usp=sharing", },
            { titulo: "✍Noun Phrases ", url: "https://drive.google.com/file/d/16oHUr1WoZ8h3OuKA3J_i7h_4-yrDMWpy/view?usp=sharing", },
            { titulo: "✍Noun Phrases 2 ", url: "https://drive.google.com/file/d/1YHlLWaR-D7oOGE7nsit_ciUJOyhGg__u/view?usp=sharing", },
            { titulo: "✍Verbs & Tenses ", url: "https://drive.google.com/file/d/1maGomb9hSFctNQciK0iQ65MS6NcBmyB9/view?usp=sharing", },
            { titulo: "✍Verbs & Tenses 2 ", url: "https://drive.google.com/file/d/1hmNX83_c71spUojY26NX0Lr1xu8lFatr/view?usp=sharing", },
            { titulo: "✍Negative Word Choice  ", url: "https://drive.google.com/file/d/1EIhDVNF1zmA3aHY5GWLMlY8yFfU0YvsJ/view?usp=sharing", },

            { titulo: "✍ Pronouns Multiple Choice  ", url: "https://drive.google.com/file/d/1NW1tqZPEhz_x-C3R_JkIxlPI2AEpo2Ip/view?usp=sharing", },
            { titulo: "✍Prepositions 1 ", url: "https://drive.google.com/file/d/1zBC_Z2Yx-v6snlVv04J7f3phtsltg9ZJ/view?usp=sharing", },
            { titulo: "✍Prepositions 2 ", url: "https://drive.google.com/file/d/1RmqHsasdx0v9YIwCH5-kQkgYl8N-PtFB/view?usp=sharing", },
            { titulo: "✍Much or Many Exercise  ", url: "https://drive.google.com/file/d/1RCGY76NB6Sw920zvaJ5XDSdHxFv3VrCh/view?usp=sharing", },
            { titulo: "✍ Some or Many Exercise  ", url: "https://drive.google.com/file/d/1FnvjpGc0aO_CYRW4X029MTHsiXeSc4nu/view?usp=sharing", },
            { titulo: "✍ Last or Latter Exercise  ", url: "https://drive.google.com/file/d/1cg_ddekwaAS49iRAbDxV0CiJlM3Y9o0R/view?usp=sharing", },
            { titulo: "✍ Superlatives  Exercise  ", url: "https://drive.google.com/file/d/1MfGGvdY2UGYMWWYg4y6pMWx6x9ijW85J/view?usp=sharing", },
            { titulo: "✍ Past Tense  Exercise  ", url: "https://drive.google.com/file/d/1xqAs1XF73eyqoH7hnyCpg_9QobkecHca/view?usp=sharing", },
            { titulo: "✍ Conditional Matching Exercise ", url: "https://drive.google.com/file/d/1pceZifEmXB5sk-AmhG4GqP00Tj63rFVA/view?usp=sharing", },

            { titulo: "✍ Gerund or Infinitive Exercise  ", url: "https://drive.google.com/file/d/1FAsG76_HqxXJIftk59cJIuM-wbXupH93/view?usp=sharing", },
            { titulo: "[📑5 Phrasal Verbs", url: "https://www.flippity.net/fc.php?k=e/2PACX-1vTaKWxtCnp5jo1jD77xTbihIoF3TG1eUiBh8mS14kM4o64z9-bSQGfIh_MoMmbDPdrlFV-z-b8XXZgx" },
            { titulo: "[📑sIMULACION", url: "https://learnibox.vercel.app/CambridgeExam" },
        ],
    },
    {
        id: 36,
        thumbnail: "https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Finalizacion del Curso",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "Descargar Certificación", url: "learnibox.vercel.app/Certificate", },

        ],
    },

];
